import React from 'react'
import styles from './styles.module.css'

function SeperatorLine() {
  return (
    <div className={styles.line}/>
  )
}

export default SeperatorLine
